var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.menu == 1)?_c('div',[_c('ScrenSolicitudAnticipoVue',{attrs:{"ObjectPedido":_vm.sendPedido,"userAsesor":Boolean(_vm.userAsesor),"groupFacturador":Boolean(_vm.groupFacturador)},on:{"rechargePedido":function($event){return _vm.$emit('rechargePedido',true)}}})],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }